module.exports = __webpack_public_path__ + "img/palm-pool.98f578ca.jpg";